export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const ADMIN_MOBILE = "ADMIN_MOBILE";
export const LOGOUT = "LOGOUT";


                                                             